import video1 from '../../Assets/video1.svg'
import video2 from '../../Assets/video2.svg'
import video3 from '../../Assets/video3.svg'
import video4 from '../../Assets/video4.svg'

export const videoColors = [
    {
        icon: video1,
        bg: '#EEF7FE',
        text: '#415EB6'
    },
    {
        icon: video2,
        bg: '#FFFBEC',
        text: '#FFB110'
    },
    {
        icon: video3,
        bg: '#F0FFFF',
        text: '#23B0B0'
    },
    {
        icon: video4,
        bg: '#FEEEEE',
        text: '#AC4040'
    }
]
